import { DetailSection, ContactField } from './content-box'
import { formatNameForDisplay } from 'lib/text-display'
import LocalPhoneOutlinedIcon from 'components/material-symbol/icons/LocalPhone'
import EmailOutlinedIcon from 'components/material-symbol/icons/Email'
import PersonOutlineIcon from 'components/material-symbol/icons/PersonOutline'
import SupervisorAccountOutlinedIcon from 'components/material-symbol/icons/SupervisorAccount'
import { useSnackbar } from 'notistack'
import { useSnackbarSuccess } from 'lib/snackbar'

export default function DisplayContact({ isMinor, contact }) {
  const { enqueueSnackbar } = useSnackbar()
  const snackbarSuccess = useSnackbarSuccess(enqueueSnackbar)

  const copyToClipboard = async (event, text) => {
    event.stopPropagation()
    navigator.clipboard.writeText(text)
    snackbarSuccess('Successfully copied to clipboard.')
  }

  if (!contact) {
    return (
      <DetailSection title="Contact" compact stacked>
        <ContactField
          icon={LocalPhoneOutlinedIcon}
          label="Phone"
          value="N/A"
          testId="student-contact-phone"
        />
        <ContactField
          icon={EmailOutlinedIcon}
          label="Email"
          value="N/A"
          testId="student-contact-email"
        />
      </DetailSection>
    )
  }

  const { firstName, lastName, phoneNumber, email, relationshipType } = contact
  const contactName = formatNameForDisplay(`${firstName} ${lastName}`)

  if (isMinor) {
    return (
      <DetailSection title="Guardian" compact stacked>
        <ContactField
          icon={PersonOutlineIcon}
          label="Name"
          value={contactName}
          testId="student-guardian-name"
        />
        <ContactField
          icon={LocalPhoneOutlinedIcon}
          label="Phone"
          value={phoneNumber || 'N/A'}
          href={phoneNumber ? `tel:${phoneNumber}` : undefined}
          onCopy={
            phoneNumber
              ? event => copyToClipboard(event, phoneNumber)
              : undefined
          }
          testId="student-guardian-phone"
        />
        <ContactField
          icon={EmailOutlinedIcon}
          label="Email"
          value={email || 'N/A'}
          href={email ? `mailto:${email}` : undefined}
          onCopy={email ? event => copyToClipboard(event, email) : undefined}
          testId="student-guardian-email"
        />
        <ContactField
          icon={SupervisorAccountOutlinedIcon}
          label="Relationship"
          value={formatNameForDisplay(relationshipType) || 'N/A'}
        />
      </DetailSection>
    )
  }

  return (
    <DetailSection title="Contact" compact stacked>
      <ContactField
        icon={LocalPhoneOutlinedIcon}
        label="Phone"
        value={phoneNumber || 'N/A'}
        href={phoneNumber ? `tel:${phoneNumber}` : undefined}
        onCopy={
          phoneNumber ? event => copyToClipboard(event, phoneNumber) : undefined
        }
        testId="student-contact-phone"
      />
      <ContactField
        icon={EmailOutlinedIcon}
        label="Email"
        value={email || 'N/A'}
        href={email ? `mailto:${email}` : undefined}
        onCopy={email ? event => copyToClipboard(event, email) : undefined}
        testId="student-contact-email"
      />
    </DetailSection>
  )
}
